class DevicesComparison {
  constructor(sectionWrapper, sectionId) {
    this.sectionWrapper = sectionWrapper;
    this.sectionId = sectionId || '';
    this.mobileBreakpoint = 992;
    this.selectsWrappers = Array.from(this.sectionWrapper.querySelectorAll('.devices-select-mobile'));
    this.selectPairs = this.selectsWrappers.map(function(w){
      return { wrapper: w, select1: w.querySelector('.device-select[name="prod1"]'), select2: w.querySelector('.device-select[name="prod2"]') };
    }).filter(function(p){ return p.select1 && p.select2; });
    this.allProducts = [];
    this.productCards = {};
    this.productVariants = {};
    this.headerEl = this.sectionWrapper.querySelector('.devices-comparison_header');
    this.stickyEl = this.sectionWrapper.querySelector('.devices-comparison_sticky');
    this.controlsEl = this.sectionWrapper.querySelector('.devices-comparison_controls');
    this.toggleBtn = this.controlsEl ? this.controlsEl.querySelector('.dc-toggle') : null;
    this.stickyProductsEl = this.stickyEl ? this.stickyEl.querySelector('.devices-comparison_products') : null;
    this.stickyThreshold = 0;
    this.stickyEndThreshold = Infinity;
    this._boundScroll = this.onScroll.bind(this);
    this._boundHandleViewChange = this.handleViewChange.bind(this);
    this._boundEqualizeHeights = this.equalizeProductCardHeights.bind(this);
  }
  getAllProducts() {
    const cards = Array.from(this.sectionWrapper.querySelectorAll('.dc-product-card'));
    const map = {};
    cards.forEach(function(card){
      const rawId = card.dataset.productId || card.getAttribute('data-product-id') || card.getAttribute('data-block-id') || '';
      if (!rawId) return;
      const titleEl = card.querySelector('.dc-product-title') || card.querySelector('.dc-stick-info_title');
      const title = titleEl ? titleEl.textContent.trim() : '';
      if (!map[rawId]) map[rawId] = { id: rawId, title: title || rawId };
      else if ((map[rawId].title === rawId || !map[rawId].title) && title) map[rawId].title = title;
    });
    return Object.values(map);
  }
  updateItems(selectedId1, selectedId2) {
    const allItems = this.sectionWrapper.querySelectorAll('.devices-comparison_tables-content-item');
    allItems.forEach(function(item) {
      const productId = item.dataset.productId;
      if (productId === selectedId1) {
        item.classList.remove('dc-item--hidden');
        item.style.order = '1';
      } else if (productId === selectedId2) {
        item.classList.remove('dc-item--hidden');
        item.style.order = '2';
      } else {
        item.classList.add('dc-item--hidden');
        item.style.order = '3';
      }
    });
    const productCards = this.sectionWrapper.querySelectorAll('.dc-product-card');
    productCards.forEach(function(card) {
      const productId = card.dataset.productId || card.getAttribute('data-product-id') || card.getAttribute('data-block-id') || '';
      if (productId === selectedId1) {
        card.classList.remove('dc-item--hidden');
        card.style.order = '1';
      } else if (productId === selectedId2) {
        card.classList.remove('dc-item--hidden');
        card.style.order = '2';
      } else {
        card.classList.add('dc-item--hidden');
        card.style.order = '3';
      }
    });
  }
  updateSelectOptions(selectToUpdate, otherSelectValue) {
    const options = selectToUpdate.options;
    for (var i = 0; i < options.length; i++) {
      options[i].hidden = options[i].value === otherSelectValue;
    }
  }
  handleSelectionChangeFromPair(pair) {
    const selected1 = pair.select1.value;
    const selected2 = pair.select2.value;
    this.selectPairs.forEach(function(p){
      p.select1.value = selected1;
      p.select2.value = selected2;
      this.updateSelectOptions(p.select1, selected2);
      this.updateSelectOptions(p.select2, selected1);
    }.bind(this));
    if (window.innerWidth <= this.mobileBreakpoint) {
      this.updateItems(selected1, selected2);
    }
    this.equalizeProductCardHeights();
  }
  handleViewChange() {
    const isMobile = window.innerWidth <= this.mobileBreakpoint;
    this.selectPairs.forEach(function(p){
      p.wrapper.style.display = isMobile ? 'flex' : 'none';
    });
    const allItems = this.sectionWrapper.querySelectorAll('.devices-comparison_tables-content-item');
    const productCards = this.sectionWrapper.querySelectorAll('.dc-product-card');
    if (isMobile) {
      const firstPair = this.selectPairs[0];
      if (firstPair) this.handleSelectionChangeFromPair(firstPair);
      this.sectionWrapper.classList.add('dc-mobile-initialized');
      if (this.stickyEl) this.stickyEl.classList.remove('dc-collapsed');
      if (this.toggleBtn) this.toggleBtn.textContent = this.toggleBtn.dataset.constrict || this.toggleBtn.textContent;
      this.updateStickyProductsHeight();
    } else {
      this.sectionWrapper.classList.remove('dc-mobile-initialized');
      allItems.forEach(function(item) {
        item.classList.remove('dc-item--hidden');
        item.style.order = '';
      });
      productCards.forEach(function(card) {
        card.classList.remove('dc-item--hidden');
        card.style.order = '';
      });
      if (this.stickyEl) this.stickyEl.classList.remove('dc-collapsed');
      if (this.stickyEl) this.stickyEl.style.removeProperty('--dc-products-h');
    }
    this.updateStickyThreshold();
    this.onScroll();
  }
  populateSelects() {
    this.selectPairs.forEach(function(p){
      p.select1.innerHTML = '';
      p.select2.innerHTML = '';
      this.allProducts.forEach(function(prod){
        const title = prod.title || prod.id;
        p.select1.add(new Option(title, prod.id));
        p.select2.add(new Option(title, prod.id));
      });
    }.bind(this));
    if (this.allProducts.length > 1) {
      const v1 = this.allProducts[0].id;
      const v2 = this.allProducts[1].id;
      this.selectPairs.forEach(function(p){
        p.select1.value = v1;
        p.select2.value = v2;
      });
    } else if (this.allProducts.length === 1) {
      const v1 = this.allProducts[0].id;
      this.selectPairs.forEach(function(p){ p.select1.value = v1; });
    }
  }
  setupProductCards() {
    const cards = this.sectionWrapper.querySelectorAll('.dc-product-card');
    const self = this;
    cards.forEach(function(card) {
      const productId = card.dataset.productId || card.getAttribute('data-product-id') || card.getAttribute('data-block-id') || '';
      if (!productId) return;
      const variantsEl = card.querySelector('.dc-variants-json');
      if (!variantsEl) return;
      var variants = [];
      try { variants = JSON.parse(variantsEl.textContent || '[]'); } catch(e) { variants = []; }
      if (!self.productCards[productId]) self.productCards[productId] = [];
      self.productCards[productId].push(card);
      self.productVariants[productId] = variants;
    });
    this.setActiveVariantForProduct = function(productId, variantId) {
      const variants = self.productVariants[productId] || [];
      const vData = variants.find(function(v){ return String(v.id) === String(variantId); }) || variants[0];
      const cardsOfProduct = self.productCards[productId] || [];
      if (!vData) return;
      cardsOfProduct.forEach(function(card){
        const imageEl = card.querySelector('.dc-product-image');
        const stickImageEl = card.querySelector('.dc-stick-image img');
        const priceCurrentEl = card.querySelector('.dc-price-current');
        const priceCompareEl = card.querySelector('.dc-price-compare');
        const stickPriceCurrentEl = card.querySelector('.dc-stick-info_price-current');
        const stickPriceCompareEl = card.querySelector('.dc-stick-info_price-compare');
        const hideOriginal = (card.dataset.hideOriginalPrice === 'true');
        const priceCurrentContainerEl = priceCurrentEl ? priceCurrentEl.parentElement : null;
        const priceCurrentPsEl = priceCurrentContainerEl ? priceCurrentContainerEl.querySelector('.dc-price-ps') : null;
        const priceCompareContainerEl = priceCompareEl ? priceCompareEl.parentElement : null;
        const priceComparePsEl = priceCompareContainerEl ? priceCompareContainerEl.querySelector('.dc-price-ps') : null;
        const stickPriceCurrentContainerEl = stickPriceCurrentEl ? stickPriceCurrentEl.parentElement : null;
        const stickPriceCurrentPsEl = stickPriceCurrentContainerEl ? stickPriceCurrentContainerEl.querySelector('.dc-stick-info_price-ps') : null;
        const stickPriceCompareContainerEl = stickPriceCompareEl ? stickPriceCompareEl.parentElement : null;
        const stickPriceComparePsEl = stickPriceCompareContainerEl ? stickPriceCompareContainerEl.querySelector('.dc-stick-info_price-ps') : null;
        const formEls = card.querySelectorAll('.dc-product-form');
        card.querySelectorAll('.dc-variant').forEach(function(v) {
          v.classList.toggle('dc-variant--active', v.dataset.variantId === String(variantId));
        });
        if (imageEl && vData.image) imageEl.src = vData.image;
        if (stickImageEl && vData.image) stickImageEl.src = vData.image;
        var priceText = vData.price_formatted;
        var compareText = vData.compare_at_price_formatted;
        if (priceCurrentEl) priceCurrentEl.textContent = priceText;
        if (stickPriceCurrentEl) stickPriceCurrentEl.textContent = priceText;
        if (priceCompareEl) {
          if (!hideOriginal && vData.compare_at_price && vData.compare_at_price > vData.price) {
            priceCompareEl.textContent = compareText;
            if (priceCompareContainerEl) priceCompareContainerEl.style.display = '';
            else priceCompareEl.style.display = '';
            if (priceCurrentPsEl) priceCurrentPsEl.style.display = '';
            if (priceComparePsEl) priceComparePsEl.style.display = '';
            if (stickPriceCompareEl) stickPriceCompareEl.textContent = compareText;
            if (stickPriceCompareContainerEl) stickPriceCompareContainerEl.style.display = '';
            else if (stickPriceCompareEl) stickPriceCompareEl.style.display = '';
            if (stickPriceCurrentPsEl) stickPriceCurrentPsEl.style.display = '';
            if (stickPriceComparePsEl) stickPriceComparePsEl.style.display = '';
          } else {
            if (priceCompareContainerEl) priceCompareContainerEl.style.display = 'none';
            else priceCompareEl.style.display = 'none';
            if (priceCurrentPsEl) priceCurrentPsEl.style.display = 'none';
            if (priceComparePsEl) priceComparePsEl.style.display = 'none';
            if (stickPriceCompareContainerEl) stickPriceCompareContainerEl.style.display = 'none';
            else if (stickPriceCompareEl) stickPriceCompareEl.style.display = 'none';
            if (stickPriceCurrentPsEl) stickPriceCurrentPsEl.style.display = 'none';
            if (stickPriceComparePsEl) stickPriceComparePsEl.style.display = 'none';
          }
        }
        formEls.forEach(function(formEl){
          const inputIdEl = formEl.querySelector('input[name="id"]');
          const primaryBtn = formEl.querySelector('.dc-btn-primary');
          const soldOutLabel = primaryBtn ? primaryBtn.getAttribute('data-sold-out-label') || 'Out of Stock' : 'Out of Stock';
          const availableLabel = primaryBtn ? primaryBtn.getAttribute('data-available-label') || (primaryBtn.textContent || '') : '';
          if (inputIdEl) inputIdEl.value = String(vData.id);

          if (primaryBtn) {
            if (vData.available) {
              primaryBtn.disabled = false;
              primaryBtn.textContent = availableLabel;
              primaryBtn.classList.remove('dc-btn-secondary');
            } else {
              primaryBtn.disabled = true;
              primaryBtn.textContent = soldOutLabel;
              primaryBtn.classList.add('dc-btn-secondary');
            }
          }
        });
      });
      self.equalizeProductCardHeights();
    };
    Object.keys(this.productCards).forEach(function(pid){
      const firstCard = self.productCards[pid] && self.productCards[pid][0];
      if (!firstCard) return;
      const firstFormInput = firstCard.querySelector('.dc-product-form input[name="id"]');
      const variants = self.productVariants[pid] || [];
      const initialId = (firstFormInput && firstFormInput.value) || (variants[0] && String(variants[0].id));
      if (initialId) self.setActiveVariantForProduct(pid, initialId);
    });
    cards.forEach(function(card){
      const productId = card.dataset.productId || card.getAttribute('data-product-id') || card.getAttribute('data-block-id') || '';
      card.querySelectorAll('.dc-variant').forEach(function(btn) {
        btn.addEventListener('click', function() { self.setActiveVariantForProduct(productId, btn.dataset.variantId); });
      });
    });
  }
  updateStickyThreshold() {
    if (!this.headerEl) { this.stickyThreshold = 0; this.stickyEndThreshold = Infinity; return; }
    var y = window.pageYOffset || window.scrollY || 0;
    var headerRect = this.headerEl.getBoundingClientRect();
    var sectionRect = this.sectionWrapper.getBoundingClientRect();
    this.stickyThreshold = y + headerRect.top + headerRect.height * 0.5;
    var sectionTop = y + sectionRect.top;
    var sectionBottom = sectionTop + sectionRect.height;
    var stickyH = this.stickyEl ? this.stickyEl.offsetHeight : 0;
    this.stickyEndThreshold = sectionBottom - stickyH;
  }
  onScroll() {
    if (!this.stickyEl) return;
    var y = window.pageYOffset || window.scrollY || 0;
    var active = y >= this.stickyThreshold && y < this.stickyEndThreshold;
    this.stickyEl.classList.toggle('active', active);
  }
  equalizeProductCardHeights() {
    const isMobile = window.innerWidth <= this.mobileBreakpoint;
    const resetInline = function(els){ els.forEach(function(el){ el.style.minHeight = ''; el.style.height = ''; }); };
    const header = this.sectionWrapper.querySelector('.devices-comparison_header');
    if (!header) return;
    this.ensurePlaceholdersForEqualize(isMobile);
    const descEls = Array.from(header.querySelectorAll('.dc-product-card .dc-product-desc'));
    const variantsEls = Array.from(header.querySelectorAll('.dc-product-card .dc-variants'));
    if (!descEls.length && !variantsEls.length) return;
    resetInline(descEls); resetInline(variantsEls);
    var maxDesc = 0;
    var maxVariants = 0;
    descEls.forEach(function(el){ maxDesc = Math.max(maxDesc, el.offsetHeight || 0); });
    variantsEls.forEach(function(el){ maxVariants = Math.max(maxVariants, el.offsetHeight || 0); });
    descEls.forEach(function(el){ el.style.minHeight = (maxDesc || 0) + 'px'; });
    variantsEls.forEach(function(el){ el.style.minHeight = (maxVariants || 0) + 'px'; });
  }
  ensurePlaceholdersForEqualize(isMobile) {
    const header = this.sectionWrapper.querySelector('.devices-comparison_header');
    if (!header) return;
    const cards = Array.from(header.querySelectorAll('.dc-product-card'));
    cards.forEach(function(card){
      var info = card.querySelector('.dc-product-info');
      var desc = card.querySelector('.dc-product-desc');
      if (!desc && info) {
        var descPh = document.createElement('p');
        descPh.className = 'dc-product-desc dc-product-desc--placeholder';
        descPh.setAttribute('aria-hidden', 'true');
        info.appendChild(descPh);
      }
      var variants = card.querySelector('.dc-variants');
      var media = card.querySelector('.dc-product-media');
      if (!variants && media) {
        var variantsPh = document.createElement('div');
        variantsPh.className = 'dc-variants dc-variants--placeholder';
        variantsPh.setAttribute('role', 'group');
        variantsPh.setAttribute('aria-hidden', 'true');
        media.insertAdjacentElement('afterend', variantsPh);
      }
    });
  }
  init() {
    if (!this.selectPairs.length) return;
    this.allProducts = this.getAllProducts();
    this.populateSelects();
    this.handleViewChange();
    this.selectPairs.forEach(function(p){
      p.wrapper.addEventListener('change', this.handleSelectionChangeFromPair.bind(this, p));
    }.bind(this));
    window.addEventListener('resize', this._boundHandleViewChange);
    this.setupProductCards();
    this.updateStickyThreshold();
    this.onScroll();
    window.addEventListener('scroll', this._boundScroll);
    if (this.toggleBtn) this.toggleBtn.addEventListener('click', this.handleToggleClick.bind(this));
    this.equalizeProductCardHeights();
    window.addEventListener('resize', this._boundEqualizeHeights);
    window.addEventListener('load', this._boundEqualizeHeights);
  }
  destroy() {
    window.removeEventListener('resize', this._boundHandleViewChange);
    window.removeEventListener('scroll', this._boundScroll);
    window.removeEventListener('resize', this._boundEqualizeHeights);
    window.removeEventListener('load', this._boundEqualizeHeights);
  }
  updateStickyProductsHeight() {
    if (!this.stickyProductsEl) return;
    if (window.innerWidth > this.mobileBreakpoint) return;
    var h = this.stickyProductsEl.scrollHeight;
    this.stickyEl.style.setProperty('--dc-products-h', h + 'px');
    this.updateStickyThreshold();
  }
  handleToggleClick() {
    if (!this.stickyEl) return;
    if (window.innerWidth > this.mobileBreakpoint) return;
    var wasCollapsed = this.stickyEl.classList.contains('dc-collapsed');
    if (wasCollapsed) {
      this.stickyEl.classList.remove('dc-collapsed');
      this.updateStickyProductsHeight();
    } else {
      this.updateStickyProductsHeight();
      this.stickyEl.classList.add('dc-collapsed');
    }
    this.updateStickyThreshold();
    var collapsed = this.stickyEl.classList.contains('dc-collapsed');
    if (this.toggleBtn) {
      var expandText = this.toggleBtn.dataset.expand || this.toggleBtn.textContent;
      var constrictText = this.toggleBtn.dataset.constrict || this.toggleBtn.textContent;
      this.toggleBtn.textContent = collapsed ? expandText : constrictText;
    }
  }
}
window.DevicesComparison = DevicesComparison;
window.__dcInstances = window.__dcInstances || {};
window.initDevicesComparison = function(sectionId) {
  var wrapper = document.getElementById('devices-comparison-' + sectionId);
  if (!wrapper) return null;
  var instance = new DevicesComparison(wrapper, sectionId);
  instance.init();
  window.__dcInstances[sectionId] = instance;
  return instance;
};
